"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const ContactTracingList_1 = __importDefault(require("./ContactTracingList"));
const contactTracingStore_1 = __importDefault(require("../../stores/contactTracingStore"));
const ContactTracingComponent = ({ covidNav, holds, peopleStore, history, searchUser, roles }) => {
    return (0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(contactTracingStore_1.default.Provider, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: searchUser, peopleStore: peopleStore, roles: roles }, { children: (0, jsx_runtime_1.jsx)(ContactTracingList_1.default, { loading: covidNav.globalTableIsLoading }) })) }) });
};
const ContactTracing = (0, mobx_react_1.inject)("covidNav", 'holds', 'roles', 'searchUser')((0, mobx_react_1.observer)(ContactTracingComponent));
exports.default = ContactTracing;
